import mixpanel from '@aqx-core/common/mixpanel';
import { TMixpanelSuperProperties } from '@aqx-core/common/mixpanel/types';

class SuperPropertiesService {
  public registerSuperProperties = (properties: TMixpanelSuperProperties) => {
    mixpanel.registerSuperProperties({
      ...properties
    });
  };
}

const superPropertiesService = new SuperPropertiesService();
export default superPropertiesService;
